module.exports = __webpack_public_path__ + "img/suggestIcon.6809c2dd.svg";